import { render, staticRenderFns } from "./TournamentCard.vue?vue&type=template&id=42248277&scoped=true&"
import script from "./TournamentCard.vue?vue&type=script&lang=js&"
export * from "./TournamentCard.vue?vue&type=script&lang=js&"
import style0 from "./TournamentCard.vue?vue&type=style&index=0&id=42248277&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42248277",
  null
  
)

component.options.__file = "TournamentCard.vue"
export default component.exports